import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import logoPath from "assets/img/api-customer-mural-logo.png";

const ImageComponent = ({ className }) => (
    <img className={className} src={logoPath} />
);

ImageComponent.propTypes = {
    className: PropTypes.string
};

const ApiCustomerMuralLogo = styled(ImageComponent)``;

export default ApiCustomerMuralLogo;
